import downloadFile from "../services/downloadFile";
import { getConfig } from "../webcoa/config";
import { icLogHistory } from "./logHistory";

/**
 * Exports the IC chat log as a timestamped text file.
 *
 * Reads from the in-memory history buffer (icLogHistory) rather than the DOM,
 * so the export always covers the entire session even though the rendered log
 * is capped for performance. A header records the server and export time.
 */
export const saveChatlogHandle = async () => {
  const lines = icLogHistory.map((e) => {
    const prefix = e.time ? `[${e.time}] ` : "";
    return `${prefix}${e.showname}: ${e.text}`.trimEnd();
  });

  let serverName = "Court of Attrition";
  try {
    serverName = getConfig().serverName;
  } catch {
    /* config not yet loaded; keep default */
  }

  const now = new Date();
  const header = [
    `${serverName} - IC chat log`,
    `Exported ${now.toLocaleString()}`,
    `${lines.length} messages`,
    "",
  ].join("\n");

  const pad = (n: number) => String(n).padStart(2, "0");
  const stamp =
    `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}` +
    `_${pad(now.getHours())}${pad(now.getMinutes())}`;
  const filename = `coa-chatlog-${stamp}.txt`;

  downloadFile(header + lines.join("\n") + "\n", filename);
};
